
/*
 * Общие функции-помогаторы
 *
 * */

window.HK = (() => {
	"use strict";
	const Decliner = {
		// Словари склонений
		DICTIONARY: {
			CHAR: ["символ", "символа", "символов"],
			DAY: ["день", "дня", "дней"],
			HOUR: ["час", "часа", "часов"],
			RUB: ["рубль", "рубля", "рублей"],
			MONTH: ["месяц", "месяца", "месяцев"],
			YEAR: ["год", "года", "лет"],
			ATTEMPT: ["попытка", "попытки", "попыток"],
			PROC: ["процент", "процента", "процентов"]
		},

		/**
		 * Склонение слов по числам (русский язык)
		 * @param {number|string} num - Число для склонения
		 * @param {string|string[]} titles - Ключ из словаря или массив из 3 форм
		 * @returns {string} Склонённая форма слова
		 */
		decline(num, titles) {
			if (num === null || num === undefined || titles === null || titles === undefined) {
				return null;
			}

			const number = Math.abs(parseInt(num, 10));
			if (isNaN(number))
				return null;

			// Если передан ключ — берём массив из словаря
			let forms;
			if (typeof titles === 'string') {
				forms = Decliner.DICTIONARY[titles.toUpperCase()];
				if (!forms)
					return null;
			} else if (Array.isArray(titles) && titles.length === 3) {
				forms = titles;
			} else {
				return null;
			}

			const cases = [2, 0, 1, 1, 1, 2];
			const index = (number % 100 > 4 && number % 100 < 20)
				? 2
				: cases[(number % 10 < 5) ? number % 10 : 5];

			return forms[index];
		},

		/**
		 * Вспомогательная функция склонения слова "фотография"
		 * @param {type} num
		 * @param {type} isAccusative -  "добавить ещё..." требует винительный падеж
		 * @returns {String}
		 */
		photoDecline(num, isAccusative = false) {
			const n = num % 100;
			const n1 = num % 10;

			if (n > 10 && n < 20)
				return 'фотографий';
			if (n1 === 1)
				return isAccusative ? 'фотографию' : 'фотография';
			if (n1 >= 2 && n1 <= 4)
				return 'фотографии';
			return 'фотографий';
		},

	};

	const StringUtils = {
		/**
		 * Сокращает строку: берёт первые maxLength символов и добавляет эллипсис в конец
		 * @param {string} str - Исходная строка
		 * @param {number} maxLength - Сколько символов оставить из строки (до добавления эллипсиса)
		 * @param {string} [ellipsis='...'] - Строка-эллипсис (по умолчанию '...')
		 * @returns {string|null} Сокращённая строка с эллипсисом или исходная, если обрезка не нужна; null при невалидных входных данных
		 */
		truncate(str, maxLength, ellipsis = '...') {
			if (str === null || str === undefined)
				return null;
			if (typeof str !== 'string')
				str = String(str);
			if (typeof maxLength !== 'number' || isNaN(maxLength) || maxLength < 0)
				return str;
			if (typeof ellipsis !== 'string')
				ellipsis = '...';

			// Если строка короче или равна maxLength — эллипсис не добавляем
			if (str.length <= maxLength)
				return str;

			// Берём нужное количество символов и прибавляем эллипсис в конец
			return str.slice(0, maxLength) + ellipsis;
		},

		decimalToHexString(number) {
			if (number < 0) {
				number = 0xFFFFFFFF + number + 1;
			}

			return number.toString(16).toUpperCase();
		},

		encode(sValue) {
			var text = "", Ucode, ExitValue, s;
			for (var i = 0; i < sValue.length; i++) {
				s = sValue.charAt(i);
				Ucode = s.charCodeAt(0);
				var Acode = Ucode;
				if (Ucode > 1039 && Ucode < 1104) {
					Acode -= 848;
					ExitValue = "%" + Acode.toString(16);
				} else if (Ucode === 1025) {
					Acode = 168;
					ExitValue = "%" + Acode.toString(16);
				} else if (Ucode === 1105) {
					Acode = 184;
					ExitValue = "%" + Acode.toString(16);
				} else if (Ucode === 32) {
					Acode = 32;
					ExitValue = "%" + Acode.toString(16);
				} else if (Ucode === 10) {
					Acode = 10;
					ExitValue = "%0A";
				} else {
					ExitValue = s;
				}
				text = text + String.fromCharCode(Acode);
			}
			return text;
		},

		/**
		 * Encodes data with MIME base64
		 *
		 * original by: Tyler Akins (http://rumkin.com)
		 * improved by: Bayron Guevara
		 *
		 * @param {type} data
		 * @returns {String}
		 */
		base64_encode(data) {
			var b64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
			var o1, o2, o3, h1, h2, h3, h4, bits, i = 0, enc = '';

			do { // pack three octets into four hexets
				o1 = data.charCodeAt(i++);
				o2 = data.charCodeAt(i++);
				o3 = data.charCodeAt(i++);

				bits = o1 << 16 | o2 << 8 | o3;

				h1 = bits >> 18 & 0x3f;
				h2 = bits >> 12 & 0x3f;
				h3 = bits >> 6 & 0x3f;
				h4 = bits & 0x3f;

				// use hexets to index into b64, and append result to encoded string
				enc += b64.charAt(h1) + b64.charAt(h2) + b64.charAt(h3) + b64.charAt(h4);
			} while (i < data.length);

			switch (data.length % 3) {
				case 1:
					enc = enc.slice(0, -2) + '==';
					break;
				case 2:
					enc = enc.slice(0, -1) + '=';
					break;
			}

			return enc;
		},

		utf8encode(string) {
			//		string = string.replace(/\r\n/g,"\n");
			var utftext = "";

			for (var n = 0; n < string.length; n++) {

				var c = string.charCodeAt(n);

				if (c < 128) {
					utftext += String.fromCharCode(c);
				} else if ((c > 127) && (c < 2048)) {
					utftext += String.fromCharCode((c >> 6) | 192);
					utftext += String.fromCharCode((c & 63) | 128);
				} else {
					utftext += String.fromCharCode((c >> 12) | 224);
					utftext += String.fromCharCode(((c >> 6) & 63) | 128);
					utftext += String.fromCharCode((c & 63) | 128);
				}

			}

			return utftext;
		},

		utf8decode(utftext) {
			var string = "";
			var i = 0;
			var c = c1 = c2 = 0;

			while (i < utftext.length) {

				c = utftext.charCodeAt(i);

				if (c < 128) {
					string += String.fromCharCode(c);
					i++;
				} else if ((c > 191) && (c < 224)) {
					c2 = utftext.charCodeAt(i + 1);
					string += String.fromCharCode(((c & 31) << 6) | (c2 & 63));
					i += 2;
				} else {
					c2 = utftext.charCodeAt(i + 1);
					c3 = utftext.charCodeAt(i + 2);
					string += String.fromCharCode(((c & 15) << 12) | ((c2 & 63) << 6) | (c3 & 63));
					i += 3;
				}

			}

			return string;
		},

		readUTF16String(bytes, bigEndian) {
			var ix = 0;
			var offset1 = 1, offset2 = 0;
			if (bytes.slice(0, 2) == "\xFE\xFF") {
				bigEndian = true;
				ix = 2;
			} else if (bytes.slice(0, 2) == "\xFF\xFE") {
				bigEndian = false;
				ix = 2;
			}

			if (bigEndian) {
				offset1 = 0;
				offset2 = 1;
			}

			var string = "";
			for (; ix < bytes.length; ix += 2) {
				var byte1 = bytes[ix + offset1].charCodeAt(0);
				var byte2 = bytes[ix + offset2].charCodeAt(0);
				var word1 = (byte1 << 8) + byte2;
				if (byte1 < 0xD8 || byte1 >= 0xE0) {
					string += String.fromCharCode(word1);
				} else {
					ix += 2;
					var byte3 = bytes[ix + offset1].charCodeAt(0);
					var byte4 = bytes[ix + offset2].charCodeAt(0);
					var word2 = (byte3 << 8) + byte4;
					string += String.fromCharCode(word1, word2);
				}
			}

			return string;
		},

		/**
		 * Первая буква заглавной
		 * @param {type} str
		 * @returns {unresolved}
		 */
		ucFirst(str) {
			if (!str) {
				return str;
			}
			return str.charAt(0).toUpperCase() + str.slice(1);
		},
		/**
		 * Удалить пробелы
		 * @param {type} value
		 * @returns {String}
		 */
		removeSpaces(value) {
			return value == null ? "" : String(value).replace(/\s/g, "");
		}

	};


	const UrlUtils = {
		getURLHash() {
			return window.location.hash ?? "";
		},

		hasStrInHash(value) {
			const hash = UrlUtils.getURLHash();
			if (!hash) {
				return false;
			}

			return hash.includes(String(value));
		},

		/**
		 * Устанавливает хэш в адресной строке
		 * @param {string} value - Значение хэша (без символа #)
		 * @param {Object} [options] - Настройки
		 * @param {boolean} [options.replace=false] - Если true, использует replaceState (не создаёт запись в истории)
		 * @param {boolean} [options.trigger=true] - Если true, вручную диспатчит событие hashchange
		 * @returns {boolean} true при успехе
		 */
		setHash(value, options = {}) {
			const {
				replace = false,
				trigger = true
			} = options;

			// Нормализация: убираем лишний #, если передали, и приводим к строке
			const cleanHash = String(value ?? '').replace(/^#/, '');
			const newHash = cleanHash ? `#${cleanHash}` : '';
			const currentHash = window.location.hash;

			// Если хэш не меняется — выходим, чтобы не делать лишнюю работу
			if (currentHash === newHash) {
				return true;
			}

			const targetUrl = window.location.pathname + window.location.search + newHash;

			try {
				if (replace) {
					// Заменяем текущую запись в истории (для фильтрации/табов)
					history.replaceState(null, '', targetUrl);
				} else {
					// Создаём новую запись (как при обычном клике на якорь)
					history.pushState(null, '', targetUrl);
				}

				if (trigger) {
					window.dispatchEvent(new HashChangeEvent('hashchange'));
				}

				return true;
			} catch (e) {
				console.error('[HK] Failed to set hash:', e);
				// Фоллбэк на прямое изменение (создаёт запись в истории и перезагружает скролл)
				window.location.hash = newHash;
				return false;
		}
		},

		clearHash() {
			if (window.location.hash) {
				history.replaceState(null, '', window.location.pathname + window.location.search);
			}
			return true;
		},

                /**
                 * Есть ли ссылка с таким значением
                 * @param {*} str
                 */
                getLink(str) {
                        if(!str) {
                                return null;
                        }

                        return [...document.querySelectorAll('a.blue-button')].find(a => a.href.toLowerCase().includes(str.toLowerCase()));
                },

		/**
		 * Переходим по первой ссылке которая совпадает с хешем
		 * @param {type} str
		 * @returns {undefined}
		 */
		goToFirstLinkByHash(str) {
			if (!HK.hasStrInHash(str)) {
				return;
			}

                        const link = HK.getLink(str);

			if (link) {
                                window.location.href = link.href;
			}
		},

		/**
		 * Получаем ссылку поиска в зависимости от того что нужно
		 *
		 * @example HK.getSearchLink({
		 lots: 'что-то',
		 search_category: '1',
		 tarif: '3',
		 isbankr: 'on',
		 })
		 * @param {type} options
		 * @returns {String} - строка поиска  '/search?q=eyJsb3RzIjoiUGFzc2F0Iiwic2VhcmNoX2NhdGVnb3J5IjoiMSJ9'
		 */
		getSearchLink(options = {}) {
			const searchParams = {};

			// Перебираем все переданные параметры
			for (const [key, value] of Object.entries(options)) {
				// Пропускаем пустые и неопределённые значения
				if (value === null || value === undefined) {
					continue;
				}

				// Обрабатываем массивы: оставляем только если есть непустые элементы
				if (Array.isArray(value)) {
					const filtered = value.filter(v =>
						v !== null && v !== undefined && String(v).trim() !== ''
					);
					if (filtered.length > 0) {
						searchParams[key] = filtered;
					}
				}
				// Обрабатываем строки: оставляем только если не пустые после тримминга
				else if (typeof value === 'string') {
					const trimmed = value.trim();
					if (trimmed !== '') {
						searchParams[key] = trimmed;
					}
				}
				// Остальные типы (числа, булевы) добавляем как есть
				else {
					searchParams[key] = value;
				}
			}

			// Если нет ни одного параметра — возвращаем базовый поиск
			if (Object.keys(searchParams).length === 0) {
				return '/search';
			}

			// Кодируем параметры в base64
			const json = JSON.stringify(searchParams);
			let base64 = Base64.encode(json);
			base64 = base64.replace(/=+$/, ''); // Убираем паддинги =

			return '/search?q=' + encodeURIComponent(base64);
		},
		/**
		 * Расшифровывает строку поиска из base64.
		 * Если аргумент не передан — берёт текущий URL страницы.
		 * Принимает либо чистый base64-код, либо полную ссылку с параметром ?q=...
		 *
		 * @param {string} [link] - base64-код, полная ссылка или пусто (используется текущий URL)
		 * @returns {Object|null} Объект с параметрами поиска или null при ошибке
		 */
		getSearchData(link) {
			// Если аргумент не передан или пустой — берём текущий URL
			if (!link || typeof link !== "string" || link.trim() === "") {
				link = window.location.href;
			}

			let base64 = link.trim();

			// Если передана полная ссылка — извлекаем параметр q
			if (base64.indexOf("?") !== -1 || base64.indexOf("&") !== -1) {
				try {
					// Пробуем через URL API (современные браузеры)
					const url = new URL(base64);
					base64 = url.searchParams.get("q") || "";
				} catch (e) {
					// Fallback для старых браузеров — парсим вручную
					const match = base64.match(/[?&]q=([^&]+)/);
					base64 = match ? decodeURIComponent(match[1]) : "";
				}
			}

			if (!base64) {
				return null;
			}

			try {
				// В search() base64 очищается от завершающих '=', восстанавливаем их
				const padding = base64.length % 4;
				if (padding === 2) {
					base64 += "==";
				} else if (padding === 3) {
					base64 += "=";
				}

				const decoded = Base64.decode(base64);
				return JSON.parse(decoded);
			} catch (e) {
				console.error("Ошибка расшифровки поисковых данных:", e);
				return null;
			}
		}
	};

	const ApiUtils = {
		// очистка значиений
		getCleanPayload(payload) {
			const json = (typeof payload === 'string') ? payload : JSON.stringify(payload);

			// Обрезаем пробелы в начале
			let cleared = json.trim();

			// Заменяем неразрывные пробелы (\u00A0) и скрытые символы форматирования на обычные
			cleared = cleared.replace(/[\u00A0\u200B\u200C\u200D\uFEFF]/g, ' ');

			return cleared;
		},

		// Показывает данные из массива строк в ввиде таблицы (например, список ошибок)
		aAlertDatainTable(arrStr, color="red") {
			if (!arrStr?.length) {
				return;
			}

			let colorHex = "";
			if(color === "red") {
				colorHex = "#ef4444";
			}

			const rows = arrStr.map(e =>
				`<tr><td style="padding:8px 12px;border:1px solid #e2e8f0;color:${colorHex};">${e}</td></tr>`
			).join('');
			aAlert(`<table style="width:100%;border-collapse:collapse;font-size:14px;">${rows}</table>`);
			//PARAMS.isStage && console.warn("ошибки: ", arrStr);
		},

	};

	// автомобили
	const CARS_API = {
		getSpec: "getCarsData?act=get_model_specs_v2",
	}

	const carsUtils = {
		/**
		 * Получить данные авто
		 * @param {type} params
		 * @returns {HelpersKit=>#7.carsUtils.getCarSpecification.HelpersKitAnonym$19|HelpersKit=>#7.carsUtils.getCarSpecification.HelpersKitAnonym$17|HelpersKit=>#7.carsUtils.getCarSpecification.result|HelpersKit=>#7.carsUtils.getCarSpecification.HelpersKitAnonym$18|HelpersKit=>#7.carsUtils.getCarSpecification.HelpersKitAnonym$20}
		 */
		async getCarSpecification(params) {
			const {auto_model_id, auto_year} = {...params};

			if (!auto_model_id) {
				return {success: false, error: "Не указан идентификатор модели авто!"};
			}
			if (!auto_year) {
				return {success: false, error: "Не указан год выпуска авто!"};
			}


			try {
				const response = await fetch(CARS_API.getSpec + `&model_id=${auto_model_id}&year=${auto_year}`);

				if (!response.ok) {
					throw new Error(`HTTP ${response.status}`);
				}

				const result = await response.json();

				if (result.length === 0) {
					return {success: false, error: "Нет данных"};
				}

				const data = result;

				return {success: true, data: data};
			} catch (e) {
				console.log("Ошибка AJAX запроса получения спецификации авто:", e);
				return {success: false, error: e};
			}
		},

		/**
		 * Проверяем, соответствуют ли данные авто конфигурациям в базе
		 * @param {Object} params
		 * @returns {Promise<{success: boolean, isCustomConfig: boolean, errors: Object, data: Array, operatorWarning?: Object}>}
		 */
		async checkCarData2(params) {
			const {maps = {}, values = {}} = {...params};
			const {engineMap = {}, driveMap = {}, transmissionMap = {}} = maps;
			const {auto_model_id, auto_year, auto_drive, auto_transmission, auto_engine, auto_power} = values;

			const getCarSpec = await this.getCarSpecification({auto_model_id, auto_year});
			if (!getCarSpec.success) {
				getCarSpec.errors = [getCarSpec.error];
				return getCarSpec;
			}

			const combinations = getCarSpec.data;

			const findNameByValue = (optionsArr, value) => {
				if (!value || !Array.isArray(optionsArr) || optionsArr.length === 0) {
					return null;
				}
				const found = optionsArr.find(opt => String(opt.value) === String(value));
				return found?.name?.toLowerCase().trim() || null;
			};

			const targetEngine = findNameByValue(engineMap, auto_engine);
			const targetDrive = findNameByValue(driveMap, auto_drive);
			const targetTransmission = findNameByValue(transmissionMap, auto_transmission);
			const targetPower = auto_power ? Math.trunc(Number(auto_power)) : null;

			// Проверяем каждое поле отдельно на существование в справочнике
			const errors = {};

			if (targetEngine) {
				const hasEngine = combinations.some(c => c['engine-type']?.toLowerCase().trim() === targetEngine);
				if (!hasEngine) {
					errors.auto_engine = "Не найдено в справочнике";
				}
			}

			if (targetDrive) {
				const hasDrive = combinations.some(c => c.drive?.toLowerCase().trim() === targetDrive);
				if (!hasDrive) {
					errors.auto_drive = "Не найдено в справочнике";
				}
			}

			if (targetTransmission) {
				const hasTransmission = combinations.some(c => c.transmission?.toLowerCase().trim() === targetTransmission);
				if (!hasTransmission) {
					errors.auto_transmission = "Не найдено в справочнике";
				}
			}

//			if (targetPower) {
//				const hasPower = combinations.some(c => c['horse-power'] === targetPower);
//				if (!hasPower) {
//					errors.auto_power = "Не найдено в справочнике";
//				}
//			}

			return {
				success: Object.keys(errors).length === 0,
				errors: errors,
				data: combinations,
			};
		},

		/**
		 * Проверяем соответствуют ли данные авто, тем что в базе
		 * @param {type} params
		 * @returns {undefined}
		 */
		async checkCarData(params) {
			const {auto_model_id, auto_year, auto_drive, auto_transmission, auto_engine, auto_power} = {...params};

			const getCarSpec = await this.getCarSpecification({auto_model_id, auto_year});
			if (!getCarSpec.success) {
				return getCarSpec; // пробрасываем ошибку дальше
			}

			const correctCarSpec = getCarSpec.data;

			// форматируем
			const power = Math.trunc(Number(auto_power));
			const drive = String(auto_drive).toLowerCase();
			const engine = String(auto_engine).toLowerCase();
			const transmission = String(auto_transmission).toLowerCase();

			// корректные данные с бэка
			const correctPowers = correctCarSpec.horse_powers;
			const correctDrives = correctCarSpec.drives;
			const correctEngines = correctCarSpec.engine_types;
			const correctTransmissions = correctCarSpec.transmissions;

			const errors = {};

			// Мощность
			if (power && correctPowers.length > 0 && !correctPowers.includes(power)) {
				errors.auto_power = true;
			}

			// Привод
			if (drive && correctDrives.length > 0 > !correctDrives.includes(drive)) {
				errors.auto_drive = true;
			}

			// Двигатель
			if (engine && correctEngines.length > 0 && !correctEngines.includes(engine)) {
				errors.auto_engine = true;
			}

			// Коробка передач
			if (transmission && correctTransmissions.length > 0 && !correctTransmissions.includes(transmission)) {
				errors.auto_transmission = true;
			}

			return {
				success: Object.keys(errors).length === 0,
				errors: errors,
				data: correctCarSpec,
			}

		},

	};

	/**
	 * Средства работы со стандартным DOM
	 * @type type
	 */
	const DomUtils = {
		// создает и возвращает DOM-пустышку. можно использовать для безопасного обращения
		makeDummy() {
			const dummy = document.createElement('div');
			dummy.querySelector = () => dummy;
			return dummy;
		},

		// проверка, что элемент реальный (не dummy)
		isRealElement(el) {
			return el && el.parentNode !== null && !el.hasAttribute('data-dummy');
		},

		// безопасный querySelector
		saveQuery(parent, selector) {
			return parent.querySelector(selector) || this.makeDummy();
		},

		// безопасный querySelectorAll — фильтрует пустые селекторы и возвращает массив
		saveQueryAll(parent, selectorsArr) {
			// Фильтруем невалидные селекторы
			const validSelectors = Array.isArray(selectorsArr)
				? selectorsArr.filter(s => s && typeof s === 'string' && s.trim() !== '')
				: [];

			if (validSelectors.length === 0) {
				return []; // возвращаем пустой массив вместо падения
			}

			try {
				return Array.from(parent.querySelectorAll(validSelectors.join(', ')));
			} catch (e) {
				console.error('HK.saveQueryAll: невалидный селектор', validSelectors, e);
				return [];
			}
		},

		// строку в дом превращает
		strToDom(htmlString) {
			const div = document.createElement('div');
			div.innerHTML = htmlString;
			return div.firstElementChild;
		},

		// фокус на поле alpine
		focusAlpineField(params = {}) {
			const {fieldName = null, invalid = true} = params;
			if (!fieldName) {
				return;
			}

			const field =
				document.querySelector(`[x-data="$f('${fieldName}')"]`) ||
				document.querySelector(`[x-field="${fieldName}"]`) ||
				document.querySelector(`[name="${fieldName}"]`) ||
				document.querySelector(`#${fieldName}`);

			if (field) {
				field.scrollIntoView({behavior: 'smooth', block: 'center'});
				field.focus();
				field.classList.add('invalid');
				setTimeout(() => field.classList.remove('invalid'), 3000);
		}
		},
	};

	// то, что будет доступно снаружи
	const publicAPI = {
		...Decliner,
		...StringUtils,
		...UrlUtils,
		...ApiUtils,
		...carsUtils,
		...DomUtils,
	};

	return publicAPI;
})();
